import { render, staticRenderFns } from "./AccessibleRemote.vue?vue&type=template&id=3ec59e90&scoped=true"
import script from "./AccessibleRemote.vue?vue&type=script&lang=js"
export * from "./AccessibleRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec59e90",
  null
  
)

export default component.exports